import { ErrorHandler, Inject, Injectable } from "@angular/core";
import { ToastsService } from "./services/toasts.service";
import { LoggingService } from "./services/logging.service";
import { AppInsightsService } from './services/app-insights.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    constructor(@Inject(ToastsService) private toastsService: ToastsService,
      private loggingService: LoggingService,
      private appInsightsService: AppInsightsService) {
    }

  handleError(error: any): void {
    // log error message or exception
    //  comenting the service way of logging for now.
    //this.loggingService.logErrorMessage(error);

    // using appinsight service to log error
    this.appInsightsService.logError(error);

    // Hide MSAL errors during mid interactions/forwarding
    /*
    //Removing this for now as there is abug opened up
    //I think this should not be an issue anymore as I am forcing user to login.
    //finally, we are logging the issue in backend so end user really does not need to see this error.
    
    if (error.message.indexOf('AADB2C99001') === -1 && error.rejection?.errorCode !== 'interaction_in_progress') {
      const defaultMessage = 'Something went wrong, please contact your administrator.';      
      this.toastsService.showError(defaultMessage);
    }   
   */
  }
}
